import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton';

const LoadingLista = () => 
{
    return <div>
        <div><Skeleton><img alt="logo de la empresa" style={{height:"125px"}} /></Skeleton></div>
        <div> <Skeleton><p>HOLA</p></Skeleton></div>
        <div><Skeleton><h1>HOLA</h1></Skeleton></div>
        <div><Skeleton><button>Ingresar</button></Skeleton></div>
    </div>
}

export default LoadingLista
